import styled from 'styled-components'

export const Img = styled.img(props => ({
  border: props.border ? '1px solid #ddd' : undefined,
  marginBottom: props.$hasCaption ? '3px' : 0
}))
